export default "__VITE_ASSET__BsBhUGVc__"